import {forwardRef, type ReactNode} from 'react';

import {ButtonRaw} from '@/components/Button';
import PageHeaderMedia from '@/components/PageHeaderMedia/PageHeaderMedia';
import type {ImageModel} from '@/types/aem';
import {twx} from '@/utils/tailwindUtils';

interface BannerProps {
    className?: string;
    'aria-label'?: string;
    'aria-hidden'?: boolean;
    onClick?: () => void;
    imageMedia?: ImageModel[];
    videoPath?: string;
    isGradient?: boolean;
    isDarkBannerText?: boolean;
    isVideoAvailable?: boolean;
    children?: ReactNode;
    gradient?: string;
    tabIndex?: number;
}

const Banner = forwardRef<HTMLElement, BannerProps>(function BannerRef(
    {
        className,
        'aria-label': ariaLabel,
        onClick,
        imageMedia,
        videoPath,
        isGradient,
        isDarkBannerText,
        isVideoAvailable,
        children,
        gradient,
        tabIndex,
        'aria-hidden': ariaHidden,
        ...rest
    },
    ref
) {
    const isButton = !!onClick;
    const Container = isButton ? ButtonRaw : 'article';

    return (
        <Container
            ref={ref}
            className={twx('relative w-full', className, {
                'text-primary': isDarkBannerText,
            })}
            aria-label={ariaLabel}
            aria-hidden={ariaHidden}
            tabIndex={tabIndex}
            onClick={onClick}
        >
            {/* @ts-expect-error: PageHeaderMedia is untyped JS */}
            <PageHeaderMedia
                isVideoAvailable={isVideoAvailable ?? !!videoPath}
                className='absolute h-full'
                videoSrc={videoPath}
                imageMedia={imageMedia}
                {...rest}
            />
            {isGradient && <div className='translate-z-1 absolute h-full w-full' style={{background: gradient}} />}
            {children}
        </Container>
    );
});

export default Banner;
